import React from "react";

import { FTFlex } from "../flex";
import { Button } from "../button";
import { useTranslation } from "react-i18next";
import { useUserStore } from "@/stores";
import { DownloadSvg, IconHistoryLine } from "@/assets/icons";
import saveAs from "file-saver";
import { getFileName, showDownloadSuccessResult } from "@/utils";
import styles from "./index.module.scss";
import Tooltip from "../tooltip";
import Analyse from "@/utils/analyse";
import useEffectStore from "@/stores/effectStore";
import { PageType } from "@/constants";

export default function PcHeaderComponent() {
  const { t } = useTranslation();
  const task = useEffectStore((state) => state.task);
  const isLogin = useUserStore((state) => state.getters.isLogin);
  const showLogin = useUserStore((state) => state.showLogin);
  const pageType = useEffectStore((state) => state.pageType);
  const handleDownload = () => {
    try {
      Analyse.getInstance().download("nav_download");
      saveAs(task!.pictureUrl!, getFileName(task!.pictureUrl!));
      Analyse.getInstance().downloadResult("nav_download");
    } catch (e) {}

    showDownloadSuccessResult(task!.pictureUrl!);
  };

  const handleRescent = () => {
    Analyse.getInstance().featureClick("recent_creation");
    const url = `${process.env.REACT_APP_BASE_URL}/cloud/all-creations/?type=face-swap`;
    if (isLogin) {
      window.open(url);
    } else {
      showLogin({
        isSignIn: true,
        options: {
          position: "my creation",
        },
        isShowScenses: true,
        callback: () => {
          window.open(url);
        },
      });
    }
  };
  return (
    <FTFlex justify="space-between" style={{ marginRight: 16 }} direction="row">
      <div className="left"></div>
      <FTFlex className={styles.right} gap={16}>
        {/* {isLogin && <div className={styles.recent} onClick={handleRescent}>
          <IconHistoryLine />
          <Tooltip content={t("recent-tip")} placement="bottom"></Tooltip>
        </div>} */}
        <Button
          primary={true}
          disabled={!task || pageType !== PageType.Result}
          style={{ borderRadius: 20 }}
          onClick={handleDownload}
        >
          <DownloadSvg />
          {t("download-button")}
        </Button>
      </FTFlex>
    </FTFlex>
  );
}
